const IMGGROUPS = {
  logo: '../../../static/img/header/logoB.png',
  findIcon: '../../../static/img/formIcons/findB.png',
  activeLine: '../../../static/img/headactive.png',
  userIcon: '../../../static/img/formIcons/loginuser.png',
  footerTractor: '../../static/img/footer/foot-url-1.png',
  dimCode: '../../static/img/footer/foot-url-3.png',
  footer: {
    phone: '../../static/img/footer/phone.png',
    mail1: '../../static/img/footer/mail.png',
    mail2: '../../static/img/footer/mail2.png',
    address: '../../static/img/footer/location.png'
  },
  product: {
    banner: '../../static/img/product/banner1_02.jpg'
  }
}

export default IMGGROUPS



// WEBPACK FOOTER //
// ./src/common/util/imgBus.js